import script from "./GeneratedContentList.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeneratedContentList.vue?vue&type=script&lang=ts&setup=true"

import "./GeneratedContentList.vue?vue&type=style&index=0&id=04475578&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04475578"]])

export default __exports__